import autocomplete from 'autocompleter';

/**
 * Remove all chips from Autocomplete
 * @param element
 * @returns {boolean}
 */
window.resetChips = function (element) {
    const chipWrap = $(element).closest('form').find('.chips');
    chipWrap.find('.chip').remove();

    return false;
};

/**
 * resetCheckboxes
 * @param element
 * @returns {boolean}
 */
window.resetCheckboxes = function (element) {
    $(element).closest('form').find('input[type="checkbox"]').prop('checked', false);

    return false;
};

/**
 * Remove single chip
 * @param element
 * @returns {boolean}
 */
window.removeChip = function (element) {
    $(element).closest('.chip').remove();

    return false;
};

/**
 * Autocomplete
 * @param elementID
 * @param helperFile
 * @param additionalElement
 * @param fillHiddenField
 */
window.autocompleteView = function (elementID, helperFile, additionalElement = '', fillHiddenField = false) {
    // input
    const input = document.getElementById(elementID);
    input.setAttribute('autocomplete', 'off');

    // chips
    const chipWrap = $(input).closest('.form-field--chip-wrap').find('.chips');

    autocomplete({
        emptyMsg: LANG_STRINGS.noResults,
        minLength: 1,
        input: input,
        preventSubmit: true,
        showOnFocus: true,
        fetch: function (text, update) {
            text = text.toLowerCase();

            // chips
            let chipList = [];
            const chipElements = chipWrap.find('.chip');
            if (chipElements.length > 0) {
                chipElements.each(function () {
                    chipList.push($(this).find('input[type="hidden"]').val());
                });
            }

            let additionalData = [];
            if (additionalElement !== '') {
                const additionalElementData = $(input).closest('form').find(additionalElement);
                if (additionalElementData.length > 0) {
                    additionalData.push(additionalElementData.val());
                }
            }

            // Ajax-Call
            $.ajax({
                url: BASE_PATH + 'ajax/autocomplete/' + helperFile,
                type: 'post',
                data: {
                    type: elementID,
                    search: text,
                    chips: chipList,
                    additionalData: additionalData,
                    allFormData: $('form').serialize(),
                },
                dataType: 'json',
                success: function (suggestions) {
                    update(suggestions);
                }
            });
        },
        onSelect: function (item) {
            if (chipWrap.length > 0) {
                chipWrap.append('<span class="chip"><span>' + item.label + '</span><i class="material-icons" onclick="removeChip(this);">cancel</i><input type="hidden" name="view[' + elementID + '][]" value="' + item.value + '"></span>');
                input.value = '';
                input.blur();
            } else {
                if (fillHiddenField === true) {
                    $(input).next('input[type=hidden]').val(item.value);
                    input.value = item.label;
                } else {
                    input.value = item.value;
                    input.label = item.value;
                }
            }
        }
    });
};